import { getDefaultI18Service, getFormatMessageFunction } from '../../tppServices/tppDi';
import { getMappedValueFromI18n } from '../../tppServices/translations/constants';
import { urlParamsParserFunctions } from './constantsParsers';
import { syncTranslationElements } from '../../tppServices/translations/intlManager';
import { generatePath } from 'react-router';
import { objectQueryBuilder } from '../requestHelpers';
import { toAvailabilityType, toPagePath } from './stateUrlCreators';
import { logger } from '../logger';

const getProductParsers = (boatConstants, config, i18nService) => {
  const t = getFormatMessageFunction(i18nService);
  const mappedValue = getMappedValueFromI18n(i18nService);

  const parsersBoats = urlParamsParserFunctions(boatConstants, config, t, mappedValue);
  // add more parsers here if needed
  // we need to map url param key to the parser function
  const productParsers = {
    'page': (page) => parsersBoats.parsePageParams(page, 'products'),
    'availabilitytype': parsersBoats.parseAvailabilityParams
  };
  return productParsers;
};

const parseProductsSearchParams = (boatConstants, urlParams, config, customUom, i18nService) => {
  const productParsers = getProductParsers(boatConstants, config, i18nService);
  let parsedParams = {};
  // not very readable but short and fast
  Object.keys(urlParams).forEach(parserFnKey => {
    if (productParsers[parserFnKey]) {
      const urlParameter = urlParams[parserFnKey];
      const urlParamParser = productParsers[parserFnKey];
      const parsed = urlParamParser(urlParameter, customUom);
      Object.assign(parsedParams, parsed);
    }
  });
  return parsedParams;
};

/**
 * Returns the URL pattern for the product page based on the provided patterns.
 * Update with other patterns as needed when new product pages exist
 * Currently only supports moorings.
 * @param patterns
 * @returns {string}
 */
/* TODO: PRIME-2024 - Add dynamic routing for Moorings */
const getProductPagePattern = (patterns/*, pageName = 'moorings'*/) => {
  return patterns.MOORINGS_SEARCH_URL_PATTERN;
};

/**
 * Generates the product path based on the provided URL properties and i18n service.
 * When (if) we have other product we need to update this function with the pageName
 * to get the correct pattern by pageName.
 * @param urlProps object containing URL properties such as availabilityType and page.
 * @param i18Service i18n service used to get the current translations.
 * @returns {*}
 */
/* TODO: PRIME-2024 - Add dynamic routing for Moorings */
const generateProductPath = (urlProps, caller, i18Service/*, pageName = 'moorings'*/) => {
  if (!i18Service) {
    i18Service = getDefaultI18Service();
  }
  const pathTranslations = i18Service.getCurrentI18n().routesConstants;
  const pathConstants = i18Service.getCurrentI18n().boatsConstants;
  const translate = syncTranslationElements(i18Service);
  try {
    // we could iterate over the urlProps and build the params dynamically with a function mapper
    // since we only have availabilityType and page, we can leave it for now
    // Change if we have more filters in the future so we only parse the ones we need
    const availabilityType = toAvailabilityType(urlProps?.availabilityType, pathTranslations, translate);
    const page = toPagePath(urlProps?.page, pathTranslations, caller);
    let urlParams = objectQueryBuilder({})
      .addParam('availabilitytype', availabilityType)
      .addParam('page', page)
      .query();
    let searchPattern = getProductPagePattern(pathConstants/*, pageName*/);
    const productPath = generatePath(searchPattern, urlParams);
    return productPath;
  } catch (error) {
    logger.error('generateProductPath error', error);
    return '';
  }

};

export { getProductParsers, parseProductsSearchParams, generateProductPath };
